import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: null,
  userData: null,
  error: null,
  showResetPasswordLink: false,
  isAuthenticated: false,
};

const loginSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess(state, action) {
      state.token = action.payload.token;
      state.userData = action.payload.userData;
      state.isAuthenticated = true;
      state.error = null;
    },
    loginFailure(state, action) {
      state.error = action.payload;
    },
    logout(state) {
      state.token = null;
      state.userData = null;
      state.error = null;
      state.isAuthenticated = false;
    },
    resetPasswordToken: (state, action) => {

      state.showResetPasswordLink = action?.payload?.showResetPasswordLink || false;
  }
  },
});

export const { loginSuccess, loginFailure, logout, resetPasswordToken } = loginSlice.actions;
export default loginSlice.reducer;
